import LoginForm from '@src/features/tenant/auth/LoginForm';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function TenantLogin() {
  return (
    <>
      <TenantCenterCardLayout>
        <LoginForm />
      </TenantCenterCardLayout>
    </>
  );
}

export default TenantLogin;
